import { WorkEmailHistoryTableColumnStore } from './work-email-history-table-column.store';
import { Component, inject, input } from '@angular/core';
import { EmailHistoryObject } from '@libs/types/src/services/object-type/email-history.object';
import { LinkButtonComponent } from '../../../kit/button/link-button.component';
import { LocalDatePipe } from '@libs/shared/pipes/local-date.pipe';
import { SlicePipe } from '@angular/common';
import { TooltipModule } from '@openng/optimus-ui/tooltip';
import { DialogModule } from '@openng/optimus-ui/dialog';
import { RenderHtmlDialogComponent } from '../../../kit/dialog/render-html-dialog/render-html-dialog.component';
import { FilterBuilder } from '../../../../modules/content/helper/filter.builder';
import {
    WorkEmailHistoryAllDialogComponent,
} from '../work-email-history-all-dialog/work-email-history-all-dialog.component';
import { BaseDialogService } from '../../../kit/base-dialog/base-dialog-service';

@Component({
    selector: 'app-work-email-history-table-column',
    templateUrl: './work-email-history-table-column.component.html',
    styleUrl: './work-email-history-table-column.component.scss',
    providers: [WorkEmailHistoryTableColumnStore],
    imports: [
        LinkButtonComponent,
        LocalDatePipe,
        SlicePipe,
        TooltipModule,
        DialogModule,
    ],
})
export class WorkEmailHistoryTableColumnComponent {

    protected readonly store = inject(WorkEmailHistoryTableColumnStore);
    protected readonly dialogService = inject(BaseDialogService);

    public emails = input<EmailHistoryObject[]>([]);
    public type = input.required<string>();
    public typeId = input.required<string>();

    protected async show(item: EmailHistoryObject): Promise<void> {
        const res = await this.store.api.getServiceEmailHistory(
            FilterBuilder.filterById(item.id),
            'content',
        );
        const content = res?.items?.[0]?.content || '';

        this.dialogService.open(
            RenderHtmlDialogComponent,
            {
                data: {
                    content,
                },
                baseZIndex: 9999,
            },
        );
    }

    protected openAll(): void {
        this.dialogService.open(
            WorkEmailHistoryAllDialogComponent,
            {
                data: {
                    type: this.type(),
                    typeId: this.typeId(),
                },
            },
        );
    }

}
